import {
  TextField as AriaTextField,
  TextFieldProps as AriaTextFieldProps,
  ValidationResult
} from 'react-aria-components'
import { tv } from 'tailwind-variants'
import {
  Description,
  FieldError,
  Input,
  Label,
  fieldBorderStyles
} from '../Field'
import { composeTailwindRenderProps, focusRing } from '../utils'

const inputStyles = tv({
  extend: focusRing,
  base: 'border border border-neutral-500 rounded-md',
  variants: {
    isFocused: fieldBorderStyles.variants.isFocusWithin,
    isInvalid: fieldBorderStyles.variants.isInvalid,
    isDisabled: fieldBorderStyles.variants.isDisabled
  }
})

export interface TextFieldProps extends AriaTextFieldProps {
  label?: string
  description?: string
  placeholder?: string
  // eslint-disable-next-line no-unused-vars
  errorMessage?: string | ((validation: ValidationResult) => string)
}

export function TextField({
  label,
  description,
  errorMessage,
  ...props
}: TextFieldProps) {
  return (
    <AriaTextField
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        'relative flex flex-col gap-1'
      )}
    >
      <Input className={inputStyles} />
      {label && <Label>{label}</Label>}
      {description && <Description>{description}</Description>}
      <FieldError>{errorMessage}</FieldError>
    </AriaTextField>
  )
}
